import { _ } from "extensions/underscore";
import $ from "jquery";

import {
    NotImplementedError
} from "common/helpers/errors";
import { isInViewport } from "common/utils";

import { DefaultView } from "../defaultView";
import template from "./customViewTemplate.jst";

export const CustomView = DefaultView.extend({
    template,
    ui: {
        widgetTitle: ".header",
        widgetContent: ".content",
        ...DefaultView.prototype.ui
    },
    
    getLoadingChildren() {
        return this.ui.widgetContent;
    },
    
    makeWidgetTitle() {
        return this.model.get("title");
    },
    
    makeContent() {
        throw new NotImplementedError();
    },
    
    lazyLoadWhenScrolled: _.throttle(function(event) {
        if (!this.isDestroyed()
            && this.isRendered()
            && isInViewport(this.el)) {
            this.setDataCollection();
            this.makeContent();
            this.reactOnGlobalChanges();
            $(window).off("scroll.chargebackWidget");
        }
    }, 100),
    
    onGridstackInit() {
        this.addWidgetTitle();
    
        // Lazy load data for children when its element is in the view
        $(window).on("scroll.chargebackWidget", this.lazyLoadWhenScrolled.bind(this));
        $(window).trigger("scroll");
    },
    
    onRender() {
        // If it's not a custom model without an api_endpoint than do not display a widget. It's malformed
        if (!this.model.isCustom && !this.model.subtypeModel.get("api_endpoint")) {
            return this.destroy();
        }
        $(window).on(`resize.dashboardwidget.${this.cid}`, _.debounce(this.reflowWidget.bind(this), 300));
    }
});
